import { render, staticRenderFns } from "./FinalPage.vue?vue&type=template&id=4ba2b37a&scoped=true&"
import script from "./FinalPage.vue?vue&type=script&lang=js&"
export * from "./FinalPage.vue?vue&type=script&lang=js&"
import style0 from "./FinalPage.vue?vue&type=style&index=0&id=4ba2b37a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba2b37a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCard,VCardActions})
